///
/// EarthBrowser
///
/// Created by Matt Giger on 9/12/2026
/// Copyright (c) 2026 Geodata Labs
///

import { useAppSelector } from "@/redux/store"
import { syncSavedViews } from "@/redux/savedViewsSync"
import { useEffect } from "react"

/**
 * Triggers saved-views delta syncs: on app start when already signed in,
 * on sign-in (anonymous local views get pushed up), and on regained
 * connectivity. Individual mutations push live via the store listener;
 * this covers everything those pushes could have missed.
 */
export function useSavedViewsSync() {
	const userId = useAppSelector(state => state.user.userProfile?.id)

	useEffect(() => {
		if (userId === undefined) return

		void syncSavedViews()

		const onOnline = () => { void syncSavedViews() }
		window.addEventListener("online", onOnline)
		return () => window.removeEventListener("online", onOnline)
	}, [userId])
}
